<template lang="pug">
  div
    span(v-html='text')
</template>

<script>

exports.default = {
  props: {
    item: { required: true },
    searchText: { required: true }
  },

  methods: {
    replacer(match) {
      return `<strong>${match}</strong>`
    }
  },


  computed: {
    text() {
      function __guard__(value, transform) {
        return (typeof value !== 'undefined' && value !== null) ? transform(value) : undefined;
      }
      return __guard__(this.item != null ? this.item.name : undefined, x => x.replace(new RegExp(this.searchText, "i"), this.replacer))
    }
  }
}

</script>

<style lang="sass">
  span.contact_count
    position: relative
    float: right
    margin-right: 22px
    &::before
      position: absolute
      content: " "
      width: 7px
      height: 8px
      right: -10px
      top: 10px
      background-image: url('../../../assets/images/icons/icon-contatos.svg')

  span.conversion
    position: relative
    float: right
    margin-right: 50px
    &::before
      position: absolute
      content: " "
      width: 8px
      height: 9px
      right: -13px
      top: 10px
      background-image: url('../../../assets/images/icons/icon-conversao.svg')
</style>



// WEBPACK FOOTER //
// property_item.vue?05fc837c